/**
 * How a cancellation letter reaches the insurer, on the `cancellation_flow`
 * aggregate.
 */
export enum CancellationSendMethod {
  EMAIL = 'EMAIL',
  REGISTERED_LETTER = 'REGISTERED_LETTER',
  IN_PERSON = 'IN_PERSON',
}

export const SELECTABLE_CANCELLATION_SEND_METHODS: readonly CancellationSendMethod[] =
  [CancellationSendMethod.EMAIL, CancellationSendMethod.REGISTERED_LETTER];

export const getCancellationSendMethodLabel = (
  method: CancellationSendMethod
): string => {
  switch (method) {
    case CancellationSendMethod.EMAIL:
      return $localize`Email`;
    case CancellationSendMethod.REGISTERED_LETTER:
      return $localize`Courrier recommandé`;
    case CancellationSendMethod.IN_PERSON:
      return $localize`En personne`;
    default:
      return method;
  }
};
